import { AxiosRequestConfig } from 'axios';
import { Agent } from 'https';

export const saveToSessionStorage = (name: string, obj: Object) => {
  try {
    const data = JSON.stringify(obj);
    sessionStorage.setItem(name, data);
  } catch (e) {
    console.error(e);
  }
};

export const loadFromSessionStorage = (name: string) => {
  try {
    const data = sessionStorage.getItem(name) || '';
    return JSON.parse(data);
  } catch (e) {
    return null;
  }
};

export const getConfig = (data?: any, type?: string): AxiosRequestConfig => {
  const token = loadFromSessionStorage('auth')?.token;
  return data
    ? {
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-type': `application/${type || 'json'}`,
          Authorization: `Bearer ${token}`,
          'X-Cookie-Info': 'currency=EUR',
        },
        data: data,
        httpsAgent: new Agent({ rejectUnauthorized: process.env.NODE_ENV === 'development' ? false : true }),
      }
    : {
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-type': `application/${type || 'json'}`,
          Authorization: `Bearer ${token}`,
          'X-Cookie-Info': 'currency=EUR',
        },
        httpsAgent: new Agent({ rejectUnauthorized: process.env.NODE_ENV === 'development' ? false : true }),
      };
};
